import dayjs from 'dayjs';

import styles from './styles.module.scss';

const MapMarkerDate = ({ value, avg }) => {
  return (
    <div className={styles.mapMarkerDate}>
      {dayjs(value).format('DD.MM.YYYY')} {avg ? <strong className={styles.mapMarkerDateValue}>avg {avg}</strong> : ''}
    </div>
  );
};

export default MapMarkerDate;
